export default __webpack_public_path__ + "static/media/piscine.7c2d096f.jpg";